// extracted by mini-css-extract-plugin
export default {"card":"K3-z","carouselContainer":"L3-z","carouselContainerOverrides":"M3-z","carouselContent":"N3-z"};